import React, { useEffect, useRef } from 'react';
import { Animated, StyleProp, StyleSheet, ViewStyle } from 'react-native';

import { useStyles } from '~/hooks';
import { scaleSize } from '~/constants/scale';
import { Theme } from '~/theme';

type Props = {
    height?: number;
    width?: number | `${number}%`;
    borderRadius?: number;
    style?: StyleProp<ViewStyle>;
};

// A pulsing placeholder block for first-load skeleton states.
export default function SkeletonRow({ height = 16, width = '100%', borderRadius = 6, style }: Props) {
    const styles = useStyles(stylesGenerator);
    const opacity = useRef(new Animated.Value(0.35)).current;

    useEffect(() => {
        const loop = Animated.loop(
            Animated.sequence([
                Animated.timing(opacity, { toValue: 0.8, duration: 700, useNativeDriver: true }),
                Animated.timing(opacity, { toValue: 0.35, duration: 700, useNativeDriver: true }),
            ])
        );
        loop.start();
        return () => loop.stop();
    }, [opacity]);

    return (
        <Animated.View
            style={[
                styles.block,
                { height: scaleSize(height), width, borderRadius: scaleSize(borderRadius), opacity },
                style,
            ]}
        />
    );
}

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        block: {
            backgroundColor: theme.equityValue,
            marginBottom: scaleSize(8),
        },
    });
